module.exports = __webpack_public_path__ + "img/img13.67490d51.svg";